import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';

export const isArrayEmpty = (array: any[] | undefined) =>
  isArray(array) && isEmpty(array);
